var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var modal = require('../layout/components/modal');
var flash = require('../components/flash');
var loaders = require('../layout/components/loaders');

var addRoomClassModal = {
  errors: [],
  name: prop(''),
  parent: prop('Room'),
  mode: 'add',
  originalName: ''
};

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function isValidClassName(name) {
  return /^[A-Za-z0-9_]+$/.test(name);
}

function showRenameWarning(oldName, newName, confirmRename) {
  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', confirmRename);
  modal.vm.title(`Rename ${oldName} to ${newName}?`);
  modal.vm.body = function () {
    return m('div', [
      m('p', `Warning, changing a class name can impact dashboards and elements configured for that class, plugins set up for the previous class name will no longer be matched. Manual updates may be necessary following this operation.`)
    ]);
  };
  modal.vm.buttons([
    {
      label: "Cancel",
      class: "dib mr2",
      func: function () {
        key.unbind('enter');
        modal.vm.close();
      }
    },
    {
      label: "Rename",
      class: "dib red",
      func: confirmRename
    }
  ]);
  modal.vm.open();
}

function openDialog(config) {
  addRoomClassModal.errors = [];
  addRoomClassModal.mode = config.mode || 'add';
  addRoomClassModal.name(config.name || '');
  addRoomClassModal.parent(config.parent || 'Room');
  addRoomClassModal.originalName = config.originalName || '';

  var submit = function (skipRenameWarning) {
    var className = (addRoomClassModal.name() || '').trim();
    var parentClass = (addRoomClassModal.parent() || 'Room').trim();

    if (!className) {
      addRoomClassModal.errors = ['Name is required'];
      return;
    }
    if (!isValidClassName(className)) {
      addRoomClassModal.errors = ['Name must use letters, numbers, or underscores only'];
      return;
    }

    if (addRoomClassModal.mode === 'edit') {
      var originalName = addRoomClassModal.originalName || className;
      if (className === originalName) {
        addRoomClassModal.errors = [];
        key.unbind('enter');
        config.submitCallback ? config.submitCallback() : '';
        modal.vm.close();
        m.redraw();
        return;
      }
      if (!skipRenameWarning) {
        showRenameWarning(originalName, className, function () {
          modal.vm.close();
          submit(true);
        });
        return;
      }
      loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/ontology/class/' + encodeURIComponent(originalName) + '?type=room',
        method: 'PUT',
        body: { name: className }
      })
      .then(() => {
        addRoomClassModal.errors = [];
        key.unbind('enter');
        config.submitCallback ? config.submitCallback() : '';
        modal.vm.close();
        m.redraw();
      })
      .catch(error => {
        var message = (error && error.message) ? error.message : 'Unable to update room class';
        addRoomClassModal.errors = [message];
        m.redraw();
      });
      return;
    }

    loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/ontology/class?type=room',
      method: 'POST',
      body: {
        name: className,
        parent: parentClass
      }
    })
    .then(() => {
      addRoomClassModal.errors = [];
      key.unbind('enter');
      config.submitCallback ? config.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(error => {
      var message = (error && error.message) ? error.message : 'Unable to create room class';
      addRoomClassModal.errors = [message];
      m.redraw();
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(addRoomClassModal.mode === 'edit' ? 'Edit Room Class: ' : 'Add Room Class: ');
  modal.vm.body = addRoomClassModal.view;

  var buttons = [];
  if (addRoomClassModal.mode === 'edit') {
    buttons.push({
      label: "Delete",
      class: "dib red mr3 ",
      func: function () {
        addRoomClassModal.deleteDialogue(
          { name: addRoomClassModal.originalName },
          config
        );
      }
    });
  }
  buttons.push({
    label: "Save",
    class: "btn-good",
    func: submit
  });

  modal.vm.buttons(buttons);

  modal.vm.open();
}

addRoomClassModal.addDialogue = function (parentRecord, options) {
  openDialog({
    mode: 'add',
    parent: parentRecord && parentRecord.name ? parentRecord.name : 'Room',
    submitCallback: options && options.submitCallback
  });
};

addRoomClassModal.editDialogue = function (record, options) {
  openDialog({
    mode: 'edit',
    name: record && record.name ? record.name : '',
    parent: record && record.parent ? record.parent : 'Room',
    originalName: record && record.name ? record.name : '',
    submitCallback: options && options.submitCallback
  });
};

addRoomClassModal.deleteDialogue = function (record, options) {
  var className = record && record.name ? record.name : '';
  if (!className) return;

  var confirmDelete = function () {
    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/ontology/class/' + encodeURIComponent(className) + '?type=room',
      method: 'DELETE'
    })
    .then(() => {
      addRoomClassModal.errors = [];
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(error => {
      var message = (error && error.message) ? error.message : 'Unable to delete room class';
      addRoomClassModal.errors = [message];
      m.redraw();
    });
  };

  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', confirmDelete);
  modal.vm.title(`Delete ${className}?`);
  modal.vm.body = function () {
    return m('div', [
      m('p', 'Are you sure you want to delete this room class?')
    ]);
  };
  modal.vm.buttons([
    {
      label: "Cancel",
      class: "dib mr2",
      func: function () {
        key.unbind('enter');
        modal.vm.close();
      }
    },
    {
      label: "Delete",
      class: "dib red",
      func: confirmDelete
    }
  ]);
  modal.vm.open();
};

addRoomClassModal.view = function () {
  var isEdit = addRoomClassModal.mode === 'edit';
  return m('form', { role: 'form' }, [
    m(flash, { items: addRoomClassModal.errors, bg: 'bg-red' }),
    m('label', isEdit ? 'Name:' : 'Name:'),
    m('input.form-control.mb2', {
      type: 'text',
      oninput: ev => addRoomClassModal.name(ev.target.value),
      value: addRoomClassModal.name()
    }),
    m('label', 'Parent:'),
    m('input.form-control', {
      type: 'text',
      disabled: true,
      value: addRoomClassModal.parent()
    })
  ]);
};

module.exports = addRoomClassModal;
